/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 * @export KYMW0600InputModel
 * @class KYMW0600InputModel
 */
export class KYMW0600InputModel {
  /** Pコード */
  public pCode: string = <string>'';
}

